import angular from 'angular';
import { NewSeatsMapService } from '../../../service/ib-new-seat-map-service';
import { Subscription } from 'rxjs';

const componentOptions = {
    bindings: {
        passengers: '<',
        currency: '<',
        segment: '<',
        passengerIndex: '<',
        someSegments: '=',
        missingSegments: '='
    },
    controllerAs: 'routeSegmentPassengersInfoCtrl',
    templateUrl: [
        '$rootScope',
        function ($rootScope) {
            return $rootScope.routes.templates + 'ib-route-segment-passengers-info.html';
        }
    ]
};

const componentInfo = {
    module: 'ib-route-segment-passengers-info-module',
    selector: 'ibRouteSegmentPassengersInfo',
    inject: ['NewSeatsMapService', '$scope', '$rootScope'],
    required: []
};

export class IbRouteSegmentPassengersInfo implements angular.IController {

    public currency: any;
    public segment: any;
    public passengers: any;
    public passengersSegment: any;
    public isSegmentSelected: boolean = false;
    public passengerIndex: any;
    public seatSelected: boolean = false;
    public someSegments: boolean;
    public missingSegments: boolean;
    private segmentSelectedSubscription: Subscription | undefined;

    constructor (
        private NewSeatsMapService: NewSeatsMapService,
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope
    ) { }


    $onInit (): void {
        this.checkIfSegmentSelected();
        this.checkIfSeatSelected();
    }

    $onDestroy (): void {
        this.segmentSelectedSubscription.unsubscribe();
    }

    checkIfSegmentSelected (): void {
        this.segmentSelectedSubscription = this.NewSeatsMapService.segmentSelected.subscribe((segment: string) => {
            if(this.segment.segmentInfo.id.toString() === segment.toString()) {
                this.isSegmentSelected = true;
            } else {
                this.isSegmentSelected = false;
                this.checkIfSeatSelected();
            }
        });
    }

    loadSegment (): void {
        this.NewSeatsMapService.setSegmentSelected(this.segment.segmentInfo.id);
        this.$scope.$emit('updateNewSeatMap', false, this.segment.segmentInfo.id);
    }

    nextFlight (): void {
        this.$scope.$emit('nextFlightNewMap');
    }

    selectPassenger (passenger: any): void {
        this.$scope.$emit('selectPassenger', passenger.id);
        this.$rootScope.$broadcast('updateCabinZones');
    }

    checkIfSeatSelected (): void {
        this.passengers.forEach(passenger => {
            if((passenger.initialSeat?.column !== '' || passenger.initialSeat?.selected )||
                (passenger.currentSeat.selected || passenger.currentSeat.column !== '')) {
                this.seatSelected = true;
            }
        });
    }

}

try {
    const mod = angular.module(componentInfo.module);
    IbRouteSegmentPassengersInfo.$inject = componentInfo.inject;
    mod.component(componentInfo.selector, angular.extend(componentOptions, { controller: IbRouteSegmentPassengersInfo }));
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    IbRouteSegmentPassengersInfo.$inject = componentInfo.inject;
    mod.component(componentInfo.selector, angular.extend(componentOptions, { controller: IbRouteSegmentPassengersInfo }));
}

